/* XSOURCE Tier 2 reveal engine (design.md §12.3) - every page, ~2 KB.
   Content is visible by default; this script adds html.js-ready and then
   reveals [data-reveal] / [data-plank] / .x-grain / .x-pendulum /
   [data-stroke-draw] / [data-star-fill] elements once, via one shared
   IntersectionObserver. GSAP is NOT required - Tier 3 choreography
   (animations.js) is a separate, template-scoped enhancement. */
(() => {
  "use strict";

  var SELECTOR = "[data-reveal],[data-plank],.x-grain,.x-pendulum,[data-stroke-draw],[data-star-fill]";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!("IntersectionObserver" in window) || reduce) {
    // Everything is already visible; nothing to do.
    return;
  }

  document.documentElement.classList.add("js-ready");

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("is-in");
          io.unobserve(entries[i].target);
        }
      }
    },
    /* Fire just BEFORE the element enters, not 15% after it already has.
       The old threshold:0.15 + a -10% bottom inset meant the reveal only
       started once the element was well inside the viewport - then it still
       had a 440ms transition plus up to ~490ms of stagger delay to run. On
       a fast scroll that reads as content popping in late and chasing the
       scroll. Expanding the bottom edge outward instead means the element
       is already mid-reveal by the time it is in view, which is what makes
       a long page feel like it flows rather than assembles. */
    { threshold: 0, rootMargin: "0px 0px 15% 0px" }
  );

  function prep(el) {
    // Stroke draw-on: precompute path lengths once, never per frame (§17.1)
    if (el.hasAttribute("data-stroke-draw")) {
      var shapes = el.querySelectorAll("path,line,circle");
      for (var i = 0; i < shapes.length; i++) {
        var len = 120;
        try { if (shapes[i].getTotalLength) len = Math.ceil(shapes[i].getTotalLength()); } catch (e) {}
        shapes[i].style.setProperty("--stroke-len", len);
      }
    }
  }

  function scan(root) {
    var els = (root || document).querySelectorAll(SELECTOR);
    var byParent = new Map();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains("is-in") || el.hasAttribute("data-revealed")) continue;
      el.setAttribute("data-revealed", "");
      // Stagger index within the same parent, capped at 8 (§12.3)
      var p = el.parentElement;
      var idx = byParent.get(p) || 0;
      if (!el.style.getPropertyValue("--reveal-i")) {
        el.style.setProperty("--reveal-i", Math.min(idx, 7));
      }
      byParent.set(p, idx + 1);
      prep(el);
      io.observe(el);
    }
  }

  window.xRevealScan = scan;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(document); });
  } else {
    scan(document);
  }

  // Shopify theme editor: re-scan injected sections
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
})();
